/**
 * The gutter a fullscreen canvas gives up for host chrome beside it (TT-972),
 * as a share of the viewport. Deliberately narrow — fullscreen is for looking
 * at the tapestry, and the panel is a reference column beside it, so it takes
 * the smallest slice the text still reads in. The floor covers narrow windows
 * where the fraction alone would be too thin for prose; the hard cap keeps
 * the tapestry well past half the screen even when the floor is binding.
 *
 * One rule for every live system: the classic canvas lays its own gutter out
 * (TapestryCanvas), the v2 stages' host does it for them (TT-1174 note 3) —
 * the panel must sit in the same column whichever board is up.
 */
const FS_ASIDE_FRACTION = 0.2;
const FS_ASIDE_MIN_PX = 300;
const FS_ASIDE_MAX_FRACTION = 0.4;

/** Pixel width of the gutter at `viewportWidth` (0 for no viewport yet). */
export function fullscreenAsideWidth(viewportWidth) {
  if (!viewportWidth) return 0;
  const want = Math.max(viewportWidth * FS_ASIDE_FRACTION, FS_ASIDE_MIN_PX);
  return Math.round(Math.min(want, viewportWidth * FS_ASIDE_MAX_FRACTION));
}

/** The same rule as a CSS width, for a stage that lays the gutter out in CSS. */
export const FULLSCREEN_ASIDE_CSS_WIDTH = `min(max(${FS_ASIDE_FRACTION * 100}vw, ${FS_ASIDE_MIN_PX}px), ${FS_ASIDE_MAX_FRACTION * 100}vw)`;
